<p-dialog class="l-dialog" [modal]="true" [(visible)]="modalVisible"
  [draggable]="false" (onHide)="closeModal()" [blockScroll]="true">
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <h2>{{ modalTitle }}</h2>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="dialog-content" [ngStyle]="{'max-width': modalWidth+'px'}">
      <p>{{ modalMessage }}</p>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button  (click)="closeModal()" class="cancel-button">{{cancelButtonText}}</button>
      <p-button  (click)="confirmAction()" class="confirm-button">{{confirmButtonText}}</p-button>
    </div>
  </ng-template>
</p-dialog>
